import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/token-group');

export const tokenGroupAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-token-group',
  UNASSIGN: 'cpms.unassign-token-group',
  SEARCH_OWNERS: 'cpms.search-token-group-owners'
};

export type AssignTokenGroupRequest = AssignModel;
export type UnassignTokenGroupRequest = AssignModel;

export const assignTokenGroup: SaveOperation<AssignTokenGroupRequest, void, string> = postRequestFactory<
  AssignTokenGroupRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: tokenGroupAccessManagementPermissions.ASSIGN
});

export const unassignTokenGroup: SaveOperation<UnassignTokenGroupRequest, void, string> = postRequestFactory<
  UnassignTokenGroupRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: tokenGroupAccessManagementPermissions.UNASSIGN
});

export const getTokenGroupOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: tokenGroupAccessManagementPermissions.SEARCH_OWNERS
});
